import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  Modal,
  Col,
  Row,
  notification,
  Layout,
  Card,
} from "antd";
import { connect } from "react-redux";
// import { Redirect } from "react-router-dom";
// import { authLogin } from "../store/actions/auth";
import { LockOutlined } from "@ant-design/icons";
import { renewPassURL } from "../constants";
import axios from "axios";
// import ExclamationCircleOutlined from "@ant-design/icons/lib/icons/ExclamationCircleOutlined";
// import Countdown from 'react-countdown';

const validateMessages = {
  required: "Vui lòng nhập ${label} !",
  types: {
    email: "${label} không đúng định dạng email!",
    number: "${label} không phải số!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};

const { Footer } = Layout;
const messageBox = (type, title, contents) => {
  notification[type]({
    message: title,
    description: contents,
  });
};
const RenderContent = () => {
  const [count, setCount] = useState(5);
  useEffect(() => {
    if (count === 0) {
      window.location.href = "/";
    }
    if (count >= 0) {
      setTimeout(() => {
        setCount(count - 1);
      }, 1000);
    }
  }, [count]);
  return (
    <a>
      Vui lòng đăng nhập lại.{" "}
      <p>
        Hệ thống sẽ điều hướng về trang đăng nhập trong {count.toString()} giây
      </p>
    </a>
  );
};

class RenewForm extends React.Component {
  state = {
    username: "",
    password: "",
    loadings: false,
    modalVisibleRestPass: false,
    showModalDone: false,
  };

  onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  fetchApiRenewPass = (params = {}) => {
    this.setState({ loading: true });
    var FormData = require("form-data");
    var data = new FormData();
    data.append("pass_new1", params.pass_new1);
    data.append("pass_new2", params.pass_new2);
    axios
      .post(renewPassURL(params.tok), data)
      .then((res) => {
        // console.log(res);
        if (res.data.error) {
          // const dataError = Object.entries(res.data.error).map(([key,value]) => <p>{value}</p>)
          messageBox("error", "Lỗi", res.data.error);
          this.setState({ modalVisibleRestPass: false });
        } else {
          // messageBox('success', 'Thông báo', res.data.message)
          messageBox("success", "Thông báo", "Đặt lại mật khẩu thành công");
          this.setState({ modalVisibleRestPass: true, showModalDone: true });
        }
        this.setState({ loading: false });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  render() {
    const { error, loading, token } = this.props;
    const { tok } = this.props.match.params;
    // if (token) {
    //   localStorage.setItem("currentSelectedKeys", JSON.stringify(['2']))
    //   return (
    //       (<Redirect to="/" />))
    // }
    const { loadings } = this.state;
    const onFinish = (values) => {
      // this.props.login(values.username, values.password);
      this.fetchApiRenewPass({
        pass_new1: values.password,
        pass_new2: values.password_confirm,
        tok: tok,
      });
    };
    const error_sv = localStorage.getItem("error_s");
    if (error_sv) {
      localStorage.removeItem("error_s");
    }
    return (
      <>
        <Layout>
          <Row
            type="flex"
            justify="center"
            align="middle"
            style={{ height: "90vh" }}
          >
            <Col>
              <Card
                title="Nhập mật khẩu mới"
                bordered={false}
                hoverable={false}
                style={{
                  boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)",
                }}
              >
                <Form
                  name="normal_login"
                  className="login-form"
                  initialValues={{
                    username: "",
                    password: "",
                    remember: true,
                  }}
                  style={{ margin: "0 auto" }}
                  onFinish={onFinish}
                >
                  {error && <p>{this.props.error.message}</p>}

                  <Form.Item
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập mật khẩu!",
                      },
                    ]}
                  >
                    <Input
                      prefix={<LockOutlined className="site-form-item-icon" />}
                      type="password"
                      placeholder="Mật khẩu"
                    />
                  </Form.Item>

                  <Form.Item
                    name="password_confirm"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập mật khẩu!",
                      },
                    ]}
                  >
                    <Input
                      prefix={<LockOutlined className="site-form-item-icon" />}
                      type="password"
                      placeholder="Nhập lại mật khẩu"
                    />
                  </Form.Item>

                  <Form.Item>
                    <Button
                      type="danger"
                      htmlType="submit"
                      className="login-form-button"
                      loading={loading}
                      onClick={() => loadings}
                    >
                      Xác nhận
                    </Button>
                    {/*Hoặc <a href="/">đăng ký tại đây!</a>*/}
                  </Form.Item>
                </Form>
                <Row>
                  <h4 style={{ color: "#a91c1c" }}>Lưu ý: </h4>
                  <h4 style={{ color: "#73879C" }}>
                    &nbsp;Mật khẩu phải ít nhất 9 ký tự bao gồm chữ hoa, chữ
                    thường, số và ký tự đặt biệt.
                  </h4>
                </Row>
              </Card>
            </Col>
          </Row>
          <Footer style={{ textAlign: "center", height: "10vh" }}>
            RAINSCALES ©{new Date().getFullYear()}
          </Footer>
        </Layout>
        <Modal
          title="Đổi mật khẩu thành công"
          visible={this.state.showModalDone}
          footer={false}
        >
          <RenderContent />
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    token: state.auth.token,
  };
};

// const mapDispatchToProps = dispatch => {
//   return {
//     login: (username, password) => dispatch(authLogin(username, password))
//   };
// };

export default connect(
  mapStateToProps
  // mapDispatchToProps
)(RenewForm);
